module.exports = __webpack_public_path__ + "img/logo_en.d2f7841d.svg";